import { DatabaseAppSettingsEnum, UserRightsEnum } from '../../../../utilities/Constants';

import Authorization from '../../../../stores/Authorization';
import { HubConnection } from '@microsoft/signalr';
import { IUserModel } from '../../../../interfaces/IUser';
import { Link } from 'react-router-dom';
import { LocalRoutes } from '../../../../utilities/LocalRoutes';
import { UserAlertList } from './UserAlertList';
import { UserTaskList } from './UserTaskList';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useGetDbAppSettings } from '../../../../shared/react-query-hooks/useGetDbAppSettings';

interface ISideNavMenuProps {
    user?: IUserModel;
    isAuthenticated?: boolean;
    alertHubConnection: HubConnection | undefined;
}

export default function SideNavMenu(props: ISideNavMenuProps) {
    const { user } = useAuthContext();
    const appSettings = useGetDbAppSettings();

    const disableCollabReportFeatureSetting = appSettings.data?.find(
        (setting) => setting.name === DatabaseAppSettingsEnum.DisableCollabReportFeature
    );

    const userHasAtLeastOneReportRight = user.organizationRoles
        ?.map((or) => or.guid)
        .some((zoneGuid) =>
            Authorization.userHasRight(UserRightsEnum.Reports, user ?? { active: false }, zoneGuid)
        );

    const showReportCounts =
        !appSettings.isFetching &&
        userHasAtLeastOneReportRight &&
        (disableCollabReportFeatureSetting?.value ?? 'false') === 'false';

    return (
        <div className="navbar pt-0">
            {props.isAuthenticated && (
                <div
                    className="navbar-container"
                    style={{ justifyContent: 'space-between', paddingBottom: '0 !important' }}
                >
                    <UserAlertList alertHubConnection={props.alertHubConnection} showReportCounts={showReportCounts} />
                    <UserTaskList />
                    <Link to={LocalRoutes.ViewSpecificPDF.replace(':id', '1')} target="_blank">
                        <i className="fal fa-graduation-cap color-green" />
                        <span className="color-green padding-left-5 uppercase">Tutorials</span>
                    </Link>
                </div>
            )}
        </div>
    );
}
